import React, {useState, useEffect} from 'react';
import axios from '@app/lib/axios';
import moment from 'moment';

import Modal from 'react-bootstrap/Modal';

import DatePicker from "react-datepicker";

import "./datepicker_custom.css";
import "./modal-size.css";

import * as Constant from '@app/Constant.js';

const AppVersionUpdateModal = ({show, onHide, data, platformList, dataCallback}) => {
    const [doSomething, setDoSomething] = useState(false);
    const [appData, setAppData] = useState(null);
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        setAppData(data);
        return () => {};
    }, [show, data]);
    
    if(!appData) {
        return (
            <Modal
                show={show}
                onHide={onHide}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        앱 업데이트 등록
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                </Modal.Body>
            </Modal>
        )
    }

    const addLog = (platform_id) => {
        platform_id = Number(platform_id);
        const hasUpdate = logs.filter(l => l.platform_id === platform_id);
        
        if(hasUpdate && hasUpdate.length > 0) {
            alert('이미 추가 되어 있습니다.');
            return;
        }

        const lastVersion = data.platformList.filter(p=> p.platform_id === platform_id);
        const logData = {};
        if(lastVersion && lastVersion.length > 0) {
            logData.major = lastVersion[0].major;
            logData.minor = lastVersion[0].minor;
            logData.revision = lastVersion[0].revision;
            logData.code = lastVersion[0].code;
        } else {
            logData.major = 0;
            logData.minor = 0;
            logData.revision = 0;
            logData.code = '';
        }

        const selectedPlatform = platformList.filter(p=> p.id === platform_id);
        
        logData.platform_icon = selectedPlatform[0].icon;
        logData.platform_name = selectedPlatform[0].name;
        logData.platform_icon_color = selectedPlatform[0].color;
        logData.platform_id = platform_id;
        logData.qa_charger = '';
        logData.deploy_date = moment().format('YYYY-MM-DD');
        logData.desc = '';

        logs.push(logData);
        setLogs(JSON.parse(JSON.stringify(logs)));
    }

    const changeValue = (e, platform_id) => {
        platform_id = Number(platform_id);
        const changeValue = logs.filter(l => l.platform_id === platform_id);
        if(changeValue && changeValue.length > 0) {
            changeValue[0][e.target.name] = e.target.value;
            setLogs(JSON.parse(JSON.stringify(logs)));
        } else {
            return;
        }

    }

    const removeLog = (platform_id) => {
        platform_id = Number(platform_id);
        const removeValue = logs.filter(l => l.platform_id !== platform_id);
        setLogs(JSON.parse(JSON.stringify(removeValue)));
    }

    const stopService = (platform_id, platform_name) => {
        if(window.confirm(`${platform_name} 서비스를 종료 하시겠습니까?`)) {
            axios({
              method: "put",
              url: Constant.API_DOMAIN+"/api/app_version/stopService/"+appData.app.id + "/" + platform_id
            })
            .then(result => {
                if(result.data.code != '200') {
                    alert(result.data.msg);
                } else {
                    alert('서비스 종료 되었습니다.');
                    onHide();
                    dataCallback(appData.app.id);
                }
              })
            .catch(error => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
        }
    }

    const submitLog = () => {
        if(!logs || logs.length === 0) {
            alert('업데이트를 추가할 플랫폼을 선택해주세요');
            return;
        }

        if(logs.filter(l => l.major === "" || l.minor === "" || l.revision === "" || l.major === "" || l.deploy_date === "").length > 0 ) {
            alert('앱 버전과 배포일은 필수 항목입니다');
            return;
        }

        axios({
          method: "post",
          url: Constant.API_DOMAIN+"/api/app_version/log/"+appData.app.id,
          data: {
            logs: logs
          }
        })
        .then(result => {
            if(result.data.code != '200') {
                alert(result.data.msg);
            } else {
                alert('저장 되었습니다.');
                // do Callback
                onHide();
                dataCallback(appData.app.id);
            }
          })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });

    }

    if(!appData) {
        return (
                <Modal
                    show={show}
                    onHide={onHide}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            앱 업데이트 등록
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body 
                        className="text-center"
                    >
                        <span className="dashboard-spinner spinner-xl"/>
                    </Modal.Body>
                </Modal>
        )
    }

	return (
		<Modal
            show={show}
            onHide={onHide}
            dialogClassName="w70"
        >   
        
        	<Modal.Header
                closeButton

            >
                <Modal.Title id="example-custom-modal-styling-title">
                    앱 업데이트 등록
                </Modal.Title>
            </Modal.Header>
            <Modal.Body
                
            >
                <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 border-right">
                        <div className="card-body pl-0 pr-0">
                            {appData && appData.app && appData.app.thumb_url && 
                                (
                                    <div className="user-avatar text-center d-block p-2">
                                        <img className="" src={appData.app.thumb_url} alt="LOGO" style={{minWidth: '100px', maxWidth: '100%', height : "128px"}}/>
                                    </div>
                                )
                            }
                            {!appData.app || !appData.app.thumb_url && 
                                (
                                    <div className="text-center p-5 " style={{fontSize: '95px'}}>
                                        <span className="fas fa-file-image" />
                                    </div>
                                )
                            }
                            <div className="text-center mb-5">
                                <h4 className="mb-2">{appData.app.name}</h4>
                            </div>
                            {appData.platformList && (
                                <ul className="list-group">
                                    {
                                        appData.platformList.map((platform)=> {
                                            return (
                                                <li 
                                                    key={`already_platform_${platform.id}`} 
                                                    className="list-group-item d-flex justify-content-between pr-3 pl-3" style={{borderRight: 'none', borderLeft: 'none'}}
                                                >
                                                    <span>
                                                        <span className={`font-22 icon-circle-sm text-${platform.platform_icon_color}`}>
                                                            <i className={`fab ${platform.platform_icon}`}></i>
                                                        </span>
                                                    </span>
                                                    <div className="text-right">
                                                        <h6 className="mb-0 ml-2">
                                                            {` ver. ${platform.major}.${platform.minor}.${platform.revision}`}
                                                            {platform.code ? ` (${platform.code})` : ''}
                                                        </h6>
                                                        <small className="ml-2 text-muted">{platform.deploy_date ? platform.deploy_date : '-'}</small>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>    
                            )}
                        </div>
                    </div>


                    <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
                        <div className="card">
                            <div className="card-header d-flex">
                                <h5>플랫폼</h5>
                                <select
                                    className="custom-select ml-auto w-auto"
                                    value="0"
                                    onChange={e=>addLog(e.target.value)}
                                >
                                    <option value="0">선택</option>
                                    {
                                        platformList && (
                                            platformList.map(p => {
                                                return <option value={p.id}>{p.name}</option>
                                            })
                                        )
                                    }
                                </select>
                            </div>
                            <div className="card-body">
                                {
                                    logs.length === 0 && (
                                        <h5 className="text-center text-muted">업데이트를 등록할 플랫폼을 선택해주세요.</h5>
                                    )
                                }
                                {
                                    logs.map((l) => {
                                        return (
                                            <>
                                                <div className="form-row pt-2">
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"> 
                                                        <h5 className="text-muted d-flex">
                                                            <span
                                                                className="fa fa-minus-circle text-danger mt-1 mr-2"
                                                                style={{cursor: 'pointer'}}
                                                                onClick={(e) => {
                                                                    removeLog(`${l.platform_id}`);
                                                                }}
                                                            />
                                                            <span className={`icon-circle-sm text-${l.platform_icon_color}`}>
                                                                <i className={`fab ${l.platform_icon}`}></i>
                                                            </span>
                                                            <span className="ml-1 mr-3">{l.platform_name}</span>
                                                        </h5>
                                                    </div> 
                                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"> 
                                                        <label htmlFor="qa_charger">QA 승인자</label>
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            name="qa_charger"
                                                            value={l.qa_charger}
                                                            onChange={(e)=> {
                                                                changeValue(e, `${l.platform_id}`);
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"> 
                                                        <label htmlFor="qa_charger">배포일</label>
                                                        <DatePicker
                                                            name="deploy_date"
                                                            selected={new Date(l.deploy_date)}
                                                            className="form-control"
                                                            onChange={(date, e)=> {
                                                                if(moment(date).isValid()) {
                                                                     changeValue({target:{name:'deploy_date', value: moment(date).format("YYYY-MM-DD")}}, `${l.platform_id}`);
                                                                } 
                                                            }}
                                                            dateFormat="yyyy-MM-dd"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row pt-2">
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"> 
                                                        <label htmlFor="qa_charger">버전</label>
                                                        <div className="input-group">
                                                            <input 
                                                                className="form-control"
                                                                type="text"
                                                                name="major"
                                                                value={l.major}
                                                                onChange={(e)=> {
                                                                    changeValue(e, `${l.platform_id}`);
                                                                }}
                                                            />
                                                            <span className="input-group-prepend"><span className="input-group-text">.</span></span>
                                                            <input 
                                                                className="form-control"
                                                                type="text"
                                                                name="minor"
                                                                value={l.minor}
                                                                onChange={(e)=> {
                                                                    changeValue(e, `${l.platform_id}`);
                                                                }}
                                                            />
                                                            <span className="input-group-prepend"><span className="input-group-text">.</span></span>
                                                            <input 
                                                                className="form-control"
                                                                type="text"
                                                                name="revision"
                                                                value={l.revision}
                                                                onChange={(e)=> {
                                                                    changeValue(e, `${l.platform_id}`);
                                                                }}
                                                            />
                                                            <span className="input-group-prepend"><span className="input-group-text">Code</span></span>
                                                            <input 
                                                                className="form-control"
                                                                type="text"
                                                                name="code"
                                                                value={l.code}
                                                                onChange={(e)=> {
                                                                    changeValue(e, `${l.platform_id}`);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-row border-bottom pt-2 pb-3">
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-2"> 
                                                        <label htmlFor="desc">내용</label>
                                                        <textarea
                                                            id="desc"
                                                            className="form-control"
                                                            name="desc"
                                                            rows={5}
                                                            value={l.desc}
                                                            onChange={(e)=> {
                                                                changeValue(e, `${l.platform_id}`);
                                                            }}
                                                        />
                                                    </div> 
                                                </div>
                                            </>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer className="text-right">
                <button
                    className="btn btn-primary"
                    onClick={submitLog}
                >
                    저장
                </button>
            </Modal.Footer>
        </Modal>
	)

}

export default AppVersionUpdateModal;